
/*
import axios from 'axios';

// Уберите /api из baseURL, оставьте только базовый URL
const API_URL = process.env.API_URL || '/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Интерцептор для добавления токена
api.interceptors.request.use(
    (config) => {
        // НЕ ДОБАВЛЯЕМ СЛЕШИ!
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Интерцептор для обработки ошибок
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Если 401 - выходим из системы
        if (error.response?.status === 401) {
            console.warn('401 Unauthorized - выходим из системы');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            
            // Проверяем, что мы не на странице логина
            if (!window.location.pathname.includes('/login')) {
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);

export const websiteAPI = {
    // ⚠️ ВАЖНО: теперь пути должны начинаться с /api/
    generate: (prompt, brief) => api.post('/websites/generate', { prompt, brief }),
    getManifest: () => api.get('/websites/manifest'),
    regenerateSection: (id, sectionId, hint) =>
        api.post(`/websites/${id}/sections/${sectionId}/regenerate`, { hint }),
    getAll: () => api.get('/websites'),
    get: (id) => api.get(`/websites/${id}`),
    update: (id, data) => api.put(`/websites/${id}`, data),
    delete: (id) => api.delete(`/websites/${id}`)
};

export default api;

*/




import axios from 'axios';

const API_URL = process.env.API_URL || '/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});


// Интерцептор для добавления токена
api.interceptors.request.use(
    (config) => {

        // FormData должен уходить как multipart с boundary,
        // который проставляет браузер. Свой Content-Type тут всё ломает.
        if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
            if (config.headers && typeof config.headers.delete === 'function') {
                config.headers.delete('Content-Type');
            } else {
                delete config.headers['Content-Type'];
            }
        }

        if (config.url && !config.url.endsWith('/') && !config.url.includes('.')) {
            config.url = config.url + '/';
        }

        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);




// Интерцептор для обработки ошибок
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            // window.location.href = '/';
        }
        return Promise.reject(error);
    }
);


//export const websiteAPI = {

    /*

    // Генерация сайта через промпт
    // generate: (prompt) => api.post('/websites/generate', { prompt }), // было
    generate: (prompt, brief) => api.post('/websites/generate', { prompt, brief }),

    getManifest: () => api.get('/websites/manifest'),

    regenerateSection: (id, sectionId, hint) =>
    api.post(`/websites/${id}/sections/${sectionId}/regenerate`, { hint }),

    // Получение всех сайтов
    getAll: () => api.get('/websites'),

    // Получение одного сайта
    get: (id) => api.get(`/websites/${id}`),

    // Обновление контента
    update: (id, data) => api.put(`/websites/${id}`, data),

    // Удаление сайта
    delete: (id) => api.delete(`/websites/${id}`)
    */
//};


export default api;
